const simplifiedMenuEN = {
  // namespace your translation keys with "sm", i.e.
  // 'sm.lorem_ipsum': 'Lorem Ipsum'
  'sm.filter_by': 'Filter By',
  'sm.all_menu_groups': 'All Menu Groups',
  'sm.no_menu_groups': 'No Menu Groups',
  'sm.menu_groups_count': '{{count}} Menu Groups',
  /* TAXES - START */
  'simplified_menu.taxes.add': 'Create Tax',
  'simplified_menu.taxes.edit': 'Edit Tax',
  'simplified_menu.taxes.back': 'Back To Taxes',
  'simplified_menu.taxes.details': 'Tax Details',

  'simplified_menu.taxes.name': 'Tax Name',
  'simplified_menu.taxes.name.required': 'Tax name is required',

  'simplified_menu.taxes.tax_percentage': 'Tax Percentage',
  'simplified_menu.taxes.tax_percentage.required': 'Tax percentage is required',
  'simplified_menu.taxes.tax_percentage.general_error':
    'Tax percentage must be between 0.001 and 100, up to three decimal places and no % symbol',

  'simplified_menu.taxes.tax_number': 'Tax Number',
  'simplified_menu.taxes.tax_number.required': 'Tax number is required',
  'simplified_menu.taxes.tax_number.input_helper':
    'Recorded for tax reporting purposes. Can enter alphanumeric text.',

  'simplified_menu.taxes.location': 'Location',
  'simplified_menu.taxes.location.input_helper':
    'To change this location, please go back to the dashboard and select',

  'simplified_menu.taxes.advanced_details': 'Advanced Details',
  'simplified_menu.taxes.total_amount_items':
    'When the total amount for all items is under or the same as',
  'simplified_menu.taxes.the_tax_rate_is': 'the tax rate is',
  'simplified_menu.taxes.exclude_from': 'Exclude this tax from',
  'simplified_menu.taxes.exclusions.0': 'Online Order',
  'simplified_menu.taxes.exclusions.1': 'In Venue',
  'simplified_menu.taxes.exclusions.2': 'Bar Tab',

  'simplified_menu.taxes.create.success.message':
    '“{{name}}” has been successfully created for {{venueName}}!',
  'simplified_menu.taxes.update.success.message':
    '“{{name}}” has been successfully updated for {{venueName}}!',
  'sm.amount': 'Amount',
  'sm.rate': 'Rate',
  /* TAXES - END */
  'sm.assign_to': 'Assign to',
  'sm.select_all': 'Select All',
  'sm.you_are_viewing': 'You are viewing:',
  'sm.search': 'Search',
  'sm.no_results_found': 'No results found.',
  'sm.empty_sales_category_img_description':
    'An image of a donut graph showing how different sales categories contribute to sales',
  'sm.edit_menu': 'Edit Menu',
  'sm.taxes': 'Taxes',
  'sm.search_taxes': 'Search taxes',
  'sm.create_tax': 'Create Tax',
  'sm.percentage': 'Percentage',
  'sm.location': 'Location',
  'sm.advanced_settings': 'Advanced Settings',
  'sm.yes': 'Yes',
  'sm.no': 'No',
  'sm.tax': 'tax',
  'sm.cancel': 'Cancel',
  'sm.delete': 'Delete',
  'sm.delete_tax': 'Delete Tax',
  'sm.delete_tax.success': '{{label}} has been deleted from Taxes',
  'sm.discount.delete_modal_title':
    "Are you sure you want to delete the discount named '{{label}}'?",
  'sm.tax.delete_modal_title': "Are you sure you want to delete the tax named '{{label}}'?",
  'sm.no_taxes_yet': "You don't have any taxes yet.",
  'sm.taxes_explanation_1':
    'Taxes are added to the price of menu items. When setting up your taxes, you can choose to add advanced tax rules. These rules allow you to customize how taxes are applied to the final bill.',
  'sm.taxes_explanation_2':
    "For instance, you can set up a rule where Tax A is only applied if the total bill is $10 or more. It's important to note that tax rates may vary depending on the geographic location of your venue.",
  'sm.tax_example': 'Tax Example',
  'sm.taxes.name.helper': 'Your tax name can be displayed to your staff and customers.',
  'sm.taxes.tax_number': 'Tax Number',
  'sm.all_taxes': 'All Taxes',
  'sm.no_taxes': 'No Taxes',
  'sm.taxes_count': '{{count}} Taxes',
  'sm.platforms': 'Platforms',
  'sm.schedule': 'Schedule',
  'sm.schedule_description.menu': 'Choose when your menu is offered.',
  'sm.schedule_description.menu_group': 'Choose when your menu group is offered.',
  'sm.availability': 'Availability',
  'sm.name': 'Name',
  'sm.price.min_error': 'Price cannot be a negative number',
  'sm.two_decimal_error': '{{field}} can only have up to 2 decimal places.',
  'sm.menu_item.name': 'Menu Item Name',
  'sm.menu_item.name.helper': 'Your menu item name can be displayed to your staff and customers.',
  'sm.menu_item.short_name': 'Short Name',
  'sm.menu_item.short_name.helper':
    'Short name will be displayed on the kitchen order ticket and receipt.',
  'sm.menu_item.description': 'Description',
  'sm.menu_item.description.helper':
    'This description can be displayed to your staff and customers.',
  'sm.menu_item.upc': 'UPC Code',
  'sm.menu_item.upc.helper': 'Scan or manually input a barcode for this menu item',
  'sm.menu_item.upc.scan_code': 'Scan Code',
  'sm.menu_item.upc.scan_upc_code': 'Scan UPC Code',
  'sm.menu_item.price': 'Price',
  'sm.menu_item.price.helper': 'Assign a price to your menu item.',
  'sm.menu_item.open_price.helper':
    'If Open Price is selected,the server must enter a price each time that item is ordered. Open-priced items will not be offered via Online Ordering.',
  'sm.menu_item.taxes.helper': 'Associated tax(s) to a menu item will also appear on the receipt.',
  'sm.menu_item.cost': 'Total cost of ingredients',
  'sm.menu_item.cost.helper':
    'How much does this cost to make? Ingredient(s) cost will be used for your reporting.',
  'sm.menu_item.menu_group.helper':
    'Attach this menu item to a menu group. For example, add Kale Salad to Salads.',
  'sm.menu_item.sales_category.helper':
    'If your menu item does not belong in the Uncategorized sales category, you can attach your menu item to another existing sales category.',
  'sm.menu_item.sales_category.choose': 'Choose a Sales Category:',
  'sm.menu_item.sales_category.bulk_update':
    'Sales category changes will apply to all selected items.',
  'sm.menu_items.menu_group.bulk_attach': 'Attach Menu Groups',
  'sm.menu_items.menu_group.bulk_attach_subtitle':
    'Select menu group(s) to attach to your menu items.',
  'sm.menu_items.menu_group.select': 'Select Menu Group(s)',
  'sm.menu_items.menu_group.updated': 'Menu Groups updated!',
  'sm.menu_item.prep_stations.placeholder': 'Search existing prep stations',
  'sm.menu_item.prep_stations.note':
    'This functionality will only add prep stations to your menu items. It does not replace or remove the prep stations attached to the menu item.',
  'sm.menu_item.prep_stations.message': 'Add or remove prep stations for the selected items.',
  'sm.menu_items.prep_station.add': 'Add Prep Station',
  'sm.menu_items.prep_station.remove': 'Remove Prep Station',
  'sm.menu_items.only_one_filter': 'Only 1 filter may be used at once',
  'sm.menu_items.no_filtered_items_found': 'You have no menu items with the selected criteria',
  'sm.menu_items.no_filtered_menu_items_data_alt': 'TouchBistro no filtered menu items image',
  'sm.menu_item.color': 'Color',
  'sm.menu_item.colors': 'Colors',
  'sm.menu_item.bulk_colors_subtitle': 'Color changes will apply to all selected items.',
  'sm.menu_item.bulk_colors_updated': 'Color has been updated!',
  'sm.course': 'Course',
  'sm.default_course': 'Default Course',
  'sm.course_description.menu_item':
    'When you assign a course to a menu item, it will be displayed on your POS. This helps differentiate the menu item from the default course assigned to the Menu Group.',
  'sm.background_color': 'Background Color',
  'sm.background_color_description.menu_item':
    'You can assign color to menu items, displaying it on connected products like your Point of Sale (POS) system. This helps your staff easily recognize menu items while taking orders.',
  'sm.background_color_description.menu_group':
    'The selected menu group color will apply to associated menu items and will appear on connected products, such as your POS.',
  'sm.course_description.menu_group':
    'Assigning a default course to a Menu group will apply to associated menu items and be displayed on connected products, such as your POS.',
  'sm.available_for': 'Available For',
  'sm.available_for_description.menu': 'Pick where your menu is offered',
  'sm.available_for_description.menu_item': 'Pick where your menu item is offered',
  'sm.available_for_note.menu_item':
    'Note: You can use the above options to manage availability for seasonal or limited menu items',
  'sm.available_for_description.modifier_group': 'Pick where your modifier group is offered',
  'sm.description': 'Description',
  'sm.pricing': 'Pricing',
  'sm.price': 'Price',
  'sm.price_value': 'Price {{price}}',
  'sm.open_price': 'Open Price Item',
  'sm.search_sales_categories': 'Search sales categories',
  'sm.search_menu_items': 'Search menu items',
  'sm.menu_name': 'Menu Name',
  'sm.menu_group_name': 'Menu Group Name',
  'sm.menu_name.description': 'Your menu name will be displayed on your connected products.',
  'sm.menu_description': 'Menu Description',
  'sm.menu_group': 'Menu Group',
  'sm.menu_groups': 'Menu Groups',
  'sm.menu_group.subheader_1':
    'When you add menu groups to your menu, it automatically includes the menu items that are associated with those groups.',
  'sm.menu_group.subheader_2':
    'For instance, if you add the "Salads" menu group to your menu, it will include menu items like "Kale Salad" and "Harvest Salad" as well. This makes it easier to manage and display menu items.',
  'sm.inventory_settings': 'Inventory Settings',
  'sm.plu_code': 'PLU Code',
  'sm.plu_code_description': 'Product look up code',
  'sm.item_out_of_stock': 'Item out of stock',
  'sm.menu_item_scheduling_description': 'Choose what hours this menu item will be available for',
  'sm.out_of_stock': 'Out of stock',
  'sm.back_in_stock': 'Back in stock',
  'sm.item_listed_out_of_stock': '{{label}} has been listed as out of stock',
  'sm.item_listed_back_in_stock': '{{label}} has been listed as back in stock',
  'sm.is_taxable': 'Is Taxable',
  'sm.item_successfully_created': '{{item}} has been successfully created',
  'sm.invalid_date': 'Invalid date',
  'sm.never_published': 'Never published',
  'sm.no_taxes_available': 'No taxes available',
  'sm.menu.printer_groups': 'Prep Stations',
  'sm.printer_group.not_available': 'No prep stations available',
  'sm.printer_group.choose': 'Choose a Prep Station:',
  'sm.printer_group.updated': 'Prep Stations updated!',
  'sm.printer_group.unassigned': 'No prep station',
  'sm.menu_items.taxes.bulk_update':
    'Tax(es) changes will add/remove to the existing tax setup for all selected items.',
  'sm.menu_items.taxes.options': 'Tax Options',
  'sm.menu_items.taxes.add': 'Add Tax(es)',
  'sm.menu_items.taxes.remove': 'Remove Tax(es)',
  'sm.menu.printer_group.attach_group_description':
    'Where would you like this menu item to print? Ex. bar printer or kitchen',
  'sm.max_3_taxes':
    'No more than three taxes can be created. Please delete a tax that is no longer required before creating a new one.',
  'sm.none': 'None',
  'sm.your_venue': 'your venue',
  'sm.manager_approval_required': 'Requires managers approval to order',
  'sm.this_item_gift_card': 'This item is a gift card',
  'sm.this_item_alcohol': 'This item contains alcohol',
  'sm.this_item_is_returnable': 'This Item can be returned',
  'sm.this_item_is_returnable.helper':
    'Check this if you need the ability to refund an item without the original bill. For example, you can do this for Bottle or Keg Deposits.',
  'sm.this_item_is_returnable.confirmation.title': 'Modifier prices will update',
  'sm.this_item_is_returnable.confirmation.submit': 'Enable Returns',
  'sm.this_item_is_returnable.confirmation.body':
    "Enabling {{label}} to be returned will update any instances it's used as a menu item modifier and change its modifier price to {{price}}. Are you sure you want to make this item returnable?",
  'sm.this_item_is_returnable.confirmation.body.backup_item_label': 'this item',
  'sm.this_item_is_returnable.confirmation.body.backup_price_label': "the item's price",
  'sm.publish.welcome_screen.title': 'Update Changes to Your POS and Online Ordering Menu!',
  'sm.publish.welcome_screen.explanation_1':
    'When you hit save within menu, your updates are not yet live. Here you will manage all your saved item and make them go live to the POS or Online Ordering by publishing them.',
  'sm.publish.welcome_screen.explanation_2':
    "This page will remain empty until you have created or updated something for your menu. Come back and publish when you're ready!",
  'sm.publish.up_to_date': `Everything is up to date at {{venue}}`,
  'sm.publish.search_placeholder': 'Search...',
  'sm.publishing_successful': 'Menu successfully published',
  'sm.publishing_successful_venue': '{{venueName}} menu was successfully published',
  'sm.publishing_failed': 'Menu publishing failed for {{venueName}}',
  'sm.details': 'Details',
  'sm.schedule_publishing': 'Schedule Publishing',
  'sm.add_edit_scheduled_publication': 'Add/Edit Scheduled Publication',
  'sm.schedule_publication': 'Schedule Publication',
  'sm.schedule_publication_message':
    'Would you like to schedule <1>all</1> your unpublished items for publishing?',
  'sm.schedule_publication_banner':
    'Your location is set to publish all items on {{publishAt}}. You have the option to <1>edit</1> or <2>delete</2> the scheduled publication. Additionally, you can publish all your changes immediately by clicking "Publish All" at the top of the page.',
  'sm.scheduled_publication_venue_success': 'Menu publication scheduled successfully',
  'sm.scheduled_publication_venues_success': 'Menu publications scheduled successfully',
  'sm.scheduled_publication_err_invalid_publishat_error':
    'Schedule time is invalid, please select a valid time',
  'sm.scheduled_publication_past_publishat_error': 'Scheduled time cannot be in the past',
  'sm.scheduled_publication_future_publishat_error':
    'Scheduled time cannot be more than 30 days in the future',
  'sm.scheduled_publication_timezone_missing':
    'Please setup your timezone in order to schedule a menu publication',
  'sm.scheduled_publication_venues_missing_timezone':
    'Please make sure the timezone is set for the following venues in order to schedule a menu publication:\n{{venues}}',
  'sm.scheduled_publication.delete_modal_title':
    'Are you sure you want to delete your scheduled publication?',
  'sm.delete_scheduled_publication': 'Delete Scheduled Publication',
  'sm.delete_scheduled_publication.success': 'Scheduled Publication has been deleted',
  'sm.delete_scheduled_publications.success': 'Scheduled Publications have been deleted',
  'sm.scheduled_publication': 'Scheduled Publication',
  'sm.type': 'Type',
  'sm.last_saved': 'Last Saved',
  'sm.last_published': 'Last Published',
  'sm.pending': '{{numberOfUpdates}} Pending',
  'sm.modified_by': 'By {{author}}',
  'sm.modifier_group.assign_to.helper': 'Attach this modifier group to an existing menu item.',
  'sm.modifier_group.assign_to.input.helper': 'Add Menu Items',
  'sm.modifier_group.modifier.instruction.name': 'Kitchen Instruction Name',
  'sm.modifier_group.modifier.new.name.input_helper':
    'Your Kitchen Instruction Name will be displayed to your staff.',
  'sm.modifier_group.updated': 'Modifier Groups have been updated!',
  'sm.modifier_group.attach': 'Attach Modifier Groups',
  'sm.modifier_group.subtitle': 'Select modifier group(s) to attach to your menu item.',
  'sm.sales_categories': 'Sales Categories',
  'sm.sales_category.name': 'Sales Category Name',
  'sm.sales_categories.updated': 'Sales Category updated!',
  'sm.all_sales_categories': 'All Sales Categories',
  'sm.sales_categories_count': '{{count}} Sales Categories',
  'sm.uncategorized': 'Uncategorized',
  'sm.taxes.updated': 'Tax updated!',
  'sm.import_menu': 'Import Menu',
  'sm.menu_import_success':
    'Your request to import the menu was submitted. Please check back in a short while to view the menu. Depending on the size of the menu, it could take longer than a minute to process the uploaded menu.',
  'sm.menu_export_success':
    'Menu export successfully requested. Please check your email in a few moments for the export.',
  'sm.importing': 'Importing..',
  'sm.export_menu': 'Export Menu',
  'sm.exporting': 'Exporting..',
  'sm.import_menu_get_template': 'Get the latest menu template here',
  'sm.drag_and_drop_helper_text': 'Drag and drop to upload your file or click to browse',
  'sm.image_file_type_error': 'Error: File type must be .png, .jpeg, .jpg',
  'sm.image_px_error':
    'Error: File must be at least 250px wide and 100px tall, and at most 1920px wide and 1080px tall',
  'sm.image_size_error': 'Error: File must be under 5MB in size',
  'sm.easy_import_image_file_type_error': 'Error: File type must be .png, .jpeg, .jpg, .webp',
  'sm.easy_import_image_size_error': 'Error: File must be under 20MB in size',
  'sm.easy_import_no_menu_selected': 'Error: No target menu selected for import',
  'sm.easy_import_no_image': 'Error: No image uploaded',
  'sm.easy_import_upload': 'Upload (Agents only)',
  'sm.easy_import_success': 'Please check back in a minute to see the imported menu',
  'sm.menu_items.share_to_group': 'Share to Group',
  'sm.menu_items.share_to_group.confirmation_modal.title':
    'Are you sure you want to share menu item "{{label}}" to the Restaurant Group?',
  'sm.menu_items.share_to_group.confirmation_modal.message':
    'Sharing this menu item moves it to the restaurant group level, so it can be shared with all venues in your group. \n\nWhen this happens, only the basic item details will be carried over. Some settings—like sales categories, modifier groups, or menu groups—won’t transfer since it is possible they do not exists at the group level. \n\nOnce shared, all venues in the group will inherit this item and any future updates made at the group level. The original item at the venue level will stay the same. \n\nIf you want it to follow group-level settings, use the Revert to Default option.',
  'sm.menu_items.no_menu_item_selected.error': 'Error: No menu item selected',
  'sm.menu_items.revert_to_default': 'Revert to Default',
  'sm.menu_items.revert_to_default.confirmation_modal.title':
    'Are you sure you want to revert this menu item "{{label}}" back to group-level settings?',
  'sm.menu_items.revert_to_default.confirmation_modal.message':
    'Choosing Revert to Default will remove any custom changes made at the venue level and update the item to match the group-level settings. For example:',
  'sm.menu_items.revert_to_default.current_venue_settings': 'Current Venue Settings:',
  'sm.menu_items.revert_to_default.current_venue_settings.name': 'Name: "Daily Special $10"',
  'sm.menu_items.revert_to_default.current_venue_settings.price': 'Price: $10',
  'sm.menu_items.revert_to_default.restaurant_group_settings': 'Restaurant Group Settings:',
  'sm.menu_items.revert_to_default.restaurant_group_settings.name': 'Name: "Daily Special"',
  'sm.menu_items.revert_to_default.restaurant_group_settings.price': 'Price: Open price',
  'sm.menu_items.revert_to_default.after_reverting_to_default': 'After Reverting to Default:',
  'sm.menu_items.revert_to_default.after_reverting_to_default.name':
    'The item name changes to "Daily Special".',
  'sm.menu_items.revert_to_default.after_reverting_to_default.price':
    'The price follows the group setting (Open price).',
  'sm.menu_items.revert_to_default.confirmation_modal.footer':
    'This ensures the menu item stays consistent across all venues in the group.',
  'sm.menu_items.linked': 'Linked',
  'sm.menu_items.linked.base_type_group': 'Group',
  'sm.menu_items.linked.base_type_venue': 'Venue',
  'sm.menu_items.updated': 'Menu items updated!',
  'sm.menu_items.out_of_stock.bulk_update':
    'Are you sure you want to mark the selected item(s) out of stock?',
  'sm.menu_items.back_in_stock.bulk_update':
    'Are you sure you want to mark the selected item(s) back in stock?',
  'sm.menu_items.modal_title.bulk_delete':
    'Are you sure you want to delete {{number}} menu item(s)?',
  'sm.mod_groups.modal_title.bulk_delete':
    'Are you sure you want to delete {{number}} modifier group(s)?',
  'sm.menu_groups.modal_title.bulk_delete':
    'Are you sure you want to delete {{number}} menu group(s)?',
  'sm.menu_groups.delete.success': "'{{label}}' has been deleted from your menu groups",
  'sm.menus.modal_title.bulk_delete': 'Are you sure you want to delete {{number}} menu(s)?',
  'sm.menus.delete.success': "'{{label}}' has been deleted from your menus",
  'sm.menu_groups.menu_items.bulk_update':
    'Menu item changes will add to the existing setup for all selected menu groups.',
  'sm.menu_groups.color': 'Color',
  'sm.menu_groups.color.bulk_update': 'Color changes will apply to all selected items.',
  'sm.menu_groups.color.bulk_update.helper': 'This color will appear on your POS.',
  'sm.icon.bulk_update': 'Icon changes will apply to all selected items.',
  'sm.icon.bulk_update.helper': 'This icon will appear on your POS.',
  'sm.menu_groups.color.updated': 'Color has been updated!',
  'sm.icon.updated': 'Icon has been updated!',
  'sm.bulk_delete.success': '{{number}} item(s) were deleted.',
  'sm.delete_modifier_group': 'Delete Modifier Group',
  'sm.added': 'Added',
  'sm.removed': 'Removed',
  'sm.bulk_pricing.explanation': 'Price changes will apply to all selected items.',
  'sm.bulk_pricing.increase': 'Increase Price',
  'sm.bulk_pricing.decrease': 'Decrease Price',
  'sm.bulk_pricing.increase_or_decrease': 'Increase or decrease prices by:',
  'sm.bulk_pricing.updated': 'Prices successfully updated!',
  'sm.menu_item_image': 'Menu Item Image',
  'sm.delete_image': 'Delete image',
  'sm.img_requirements':
    'Please upload images that are at least 250px wide, 100px tall and maximum 1920px wide and 1080px tall, in a PNG or JPG file format and under 5MB in size. This image will be used in Online Ordering and POS if enabled.',
  'sm.full_menu': 'Full Menu',
  'sm.admin_register': 'Admin: Register',
  'sm.current_order': "Current Order For Admin's Register",
  'sm.back_to_publishing': 'Back to Publishing',
  'sm.open': 'Open',
  'sm.available_for.updated': '"Available For" updated!',
  'sm.no_available_for_available': 'No "Available For" available',
  'sm.menu_items.available_for.options': '"Available For" Options',
  'sm.menu_items.available_for.add': 'Add "Available For"',
  'sm.menu_items.available_for.remove': 'Remove "Available For"',
  'sm.menu_items.available_for.bulk_update':
    '"Available For" changes will add/remove where your menu item is offered for all selected items.',
  // promotional pricing
  'sm.promotional_pricing': 'Promotional Pricing',
  'sm.promotional_pricing_explanation':
    'Promotional Pricing allows you to offer special deals and discounts on your menu items during a specific period of time. This can be achieved by using the discounts you\'ve set up or by offering a fixed price. Examples of Promotional Pricing include happy hour deals, holiday prices, or reduced pricing for specific menu items during non-peak times. To get started, click "Add Promotion" in the top right corner.',
  'sm.fixed_price_promotion_example': 'Fixed Price Promotion Example',
  'sm.discount_promotion_example': 'Discount Promotion Example',
  'sm.Promotion': 'Promotion',
  'sm.promotion': 'promotion',
  'sm.promotion_type': 'Promotion Type',
  'sm.promotion_type_discount': 'Discount',
  'sm.promotion_type_fixed_price': 'Fixed Price',
  'sm.add_promotion': 'Add Promotion',
  'sm.edit_promotion': 'Edit Promotion',
  'sm.search_promotion_placeholder': 'Search promotions',
  'sm.promotions.modal_title.bulk_delete':
    'Are you sure you want to delete {{total}} promotion(s)?',
  'sm.promotions.modal_title.delete':
    "Are you sure you want to delete the promotion named '{{label}}'?",
  'sm.promotion.delete_promotion': 'Delete Promotion',
  'sm.promotions.delete.success': "'{{label}}' has been deleted from your promotions",
  'sm.promotions.back': 'Back to Promotions',
  'sm.promotion_details': 'Promotion Details',
  'sm.promotion.create.name_label': 'Promotion Name',
  'sm.promotion.create.name_helper':
    'Your promotion name can be displayed to your staff and customers.',
  'sm.promotion.discount_select_option': 'Select Discount Option',
  'sm.promotion_price': 'Promotion Price',
  'sm.promotion_price_helper_text':
    'The promotional price cannot exceed the menu price. If promotional price exceeds menu price, the item(s) will continue to be sold at their current menu price.',
  'sm.schedule_description.promotion': 'Choose when your promotion is offered.',
  'sm.promotion.discount_option': 'Discount Option',
  'sm.promotion_attach_menu_group_and_item':
    'Select Menu Groups/Menu Items that this Promotion can be applied to.',
  'sm.promotion_attach_menu_group_and_item_button': 'Search Menu Groups/Menu Items',
  'sm.promotion_title_menu_group': 'Select Menu Groups/Items',
  'sm.promotion_title_menu_item': 'Select Menu Items',
  'sm.promotion_attach_menu_group_and_item_subtitle':
    'The selected menu groups/items will be applied the discount.',
  'sm.promotion_attach_menu_group_and_item_banner_title': 'Heads up!',
  'sm.promotion_subtitle_menu_group':
    'Promotion will automatically include all subsequent additions to Menu Groups.',
  'sm.promotion_subtitle_menu_item':
    'Promotion will be applied to specific Menu Items you select. When all Menu Items are selected, the promotion will apply to the Menu Group. Promotion will automatically include all subsequent additions to Menu Groups.',
  'sm.promotion_back_to_all': 'Back to menu groups',
  'sm.promotion_view_menu_items': 'View Menu Items',
  'sm.promotion_no_menu_groups': 'There are no Menu Groups.',
  'sm.promotion_no_menu_items': 'There are no Menu Items for this Menu Group.',
  'sm.promotion_price_error':
    'Promotion price must be a decimal with maximum two digits after comma',
  // empty screens
  'sm.empty_screen_receipt_venue': 'TouchBistro Cafe',
  'sm.empty_screen_receipt_street_address': '590 King Street West',
  'sm.empty_screen_receipt_city_address': 'Toronto, ON',
  'sm.empty_screen_receipt_country_address': 'Canada, L6M 4H7',
  'sm.empty_screen_receipt_venue_phone': '(905)-399-5432',
  'sm.empty_screen_receipt_date': 'February 15, 2020 at 3:53 PM',
  'sm.empty_screen_receipt_table': 'Table: Cash Register, 1 guest',
  'sm.empty_screen_receipt_party': 'Party Name: 1',
  'sm.empty_screen_receipt_tax': 'Tax #: R0012345654323',
  'sm.empty_screen_receipt_order': 'Order: 5870',
  'sm.empty_screen_receipt_admin': 'Admin: Emily',
  'sm.empty_screen_receipt_item_veggie_tacos': 'Veggie Tacos',
  'sm.empty_screen_receipt_item_veggie_tacos_modifier': '+ No Lettuce',
  'sm.empty_screen_receipt_friday_lunch_discount': 'Discount - Lunch Friday',
  'sm.empty_screen_receipt_taco_tuesday_promotion': '$11.29 - $6.29 - Taco Tuesday',
  'sm.empty_screen_receipt_happy_hour_promotion': 'Promotion - Happy Hour',
  'sm.empty_screen_receipt_item_orange_juice': 'Orange Juice',
  'sm.empty_screen_receipt_item_orange_juice_modifier': '+ No Pulp',
  'sm.empty_screen_receipt_item_orange_juice_mimosa': 'Orange Juice Mismosa',
  'sm.empty_screen_receipt_item_veggie_tacos_cost': '$11.29',
  'sm.empty_screen_receipt_item_veggie_tacos_discounted_cost': '$5.00',
  'sm.empty_screen_receipt_item_veggie_tacos_discount_amount': '-$2.82',
  'sm.empty_screen_receipt_item_orange_juice_mimosa_cost': '$13.55',
  'sm.empty_screen_receipt_item_orange_juice_discount_amount': '-$2.03',
  'sm.empty_screen_receipt_bill_amount_due': 'Amount Due',
  'sm.empty_screen_receipt_bill_amount_due_taxes': '$24.84',
  'sm.empty_screen_receipt_bill_discounted_amount_due': '$19.99',
  'sm.empty_screen_receipt_bill_promotions_amount_due': '$18.55',
  'sm.empty_screen_receipt_bill_hst': 'HST (13%):',
  'sm.empty_screen_receipt_bill_tip': 'Tip',
  'sm.empty_screen_receipt_bill_total': 'Total',
  'sm.empty_screen_receipt_bill_hst_value_taxes': '$3.23',
  'sm.empty_screen_receipt_bill_hst_value_discounts': '$2.60',
  'sm.empty_screen_receipt_bill_hst_value_promotions': '$2.41',
  'sm.empty_screen_receipt_bill_tip_value': '$4.50',
  'sm.empty_screen_receipt_bill_total_value_taxes': '$32.57',
  'sm.empty_screen_receipt_bill_total_value_discounts': '$27.09',
  'sm.empty_screen_receipt_bill_total_value_promotions': '$25.46',
  'sm.empty_screen_receipt_footer_thank_you': 'Thank You!',
  'sm.empty_screen_receipt_footer_come_again': 'Please Come Again',
  // errors
  'sm.label_max_length': 'Label is longer than 500 characters',
  'sm.item_label_max_length': 'Label is longer than 1000 characters',
  'sm.description_max_length': 'Description is longer than 1000 characters',
  'sm.upc_max_length': 'UPC Code is longer than 255 characters',
  'sm.plu_max_length': 'PLU Code is longer than 255 characters',
  'sm.error.upc_duplicate':
    'UPC is already in use by another menu item. Please input a unique product code.',
  'sm.error.upc_duplicate_multi_item_create':
    'Menu Items: {{menuItemLabels}} have duplicate UPC Codes',
  'sm.error.no_negative_value': "This field can't contain negative value",
  'sm.error.schedule.menu': 'Please select the day(s) your menu is available.',
  'sm.error.schedule.menu_group': 'Please select the day(s) your menu group is available.',
  'sm.error.duplicate_schedules': 'Cannot create duplicate schedules.',
  'sm.error.open_and_returnable': 'Open Priced Items cannot have returns enabled.',
  'sm.error.promo_code_duplicate':
    'This promo code is already in use. Please enter a different code.',
  'sm.error.promo_code_invalid_time_range': 'Promo code start time must be before its end time.',

  'sm.easy_assign_sales_categories': 'Auto Assign Sales Categories',
  'sm.easy_assign_sales_categories_title': 'Sales Categories',
  'sm.easy_assign_sales_categories_empty_state': 'All menu items are categorized',
  'sm.easy_assign_sales_categories_something_went_wrong': 'Something went wrong',

  // entity history
  'sm.pending_updates': 'Pending Updates',
  'sm.pending_updates.subtitle':
    'These are your updates to the unpublished item since the last publishing.',
  'sm.entity_history.field_name': '{{key}}',
  'sm.entity_history.field_name_plu': 'PLU Code',
  'sm.entity_history.field_name_color': 'Background Color',
  'sm.entity_history.field_name_label': 'Name',
  'sm.entity_history.field_name_prices': 'Pricing',
  'sm.entity_history.field_name_taxes': 'Taxes',
  'sm.entity_history.field_name_taxRules': 'Tax Rules',
  'sm.entity_history.field_name_takeoutTypes': 'Tax Exclusions',
  'sm.entity_history.field_name_menuGroups': 'Menu Groups',
  'sm.entity_history.field_name_menuItems': 'Menu Items',
  'sm.entity_history.field_name_bogoGetMenuGroups': 'Get Menu Groups',
  'sm.entity_history.field_name_bogoGetMenuItems': 'Get Menu Items',
  'sm.entity_history.field_name_menus': 'Menus',
  'sm.entity_history.field_name_printerGroups': 'Printer Groups',
  'sm.entity_history.field_name_modifierGroups': 'Modifier Groups',
  'sm.entity_history.field_name_images': 'Image',
  'sm.entity_history.field_name_shortName': 'Short Name',
  'sm.entity_history.field_name_isGiftCard': 'This item is a gift card',
  'sm.entity_history.field_name_isAlcohol': 'This item contains alcohol',
  'sm.entity_history.field_name_isReturnable': 'This Item can be returned',
  'sm.entity_history.field_name_description': 'Description',
  'sm.entity_history.field_name_isOutOfStock': 'Item out of stock',
  'sm.entity_history.field_name_salesChannels': 'Available For',
  'sm.entity_history.field_name_rank': 'Rank',
  'sm.entity_history.field_name_schedule': 'Schedule',
  'sm.entity_history.field_name_salesCategoryName': 'Sales Category',
  'sm.entity_history.field_name_courseName': 'Course',
  'sm.entity_history.field_name_requiresManagersApproval': 'Requires managers approval to order',
  'sm.entity_history.field_name_icon': 'Icon',
  'sm.entity_history.field_name_backgroundColor': 'Background Color',
  'sm.entity_history.field_name_maxSelection': 'Maximum Modifiers',
  'sm.entity_history.field_name_minSelection': 'Minimum Modifiers',
  'sm.entity_history.field_name_modifiers': 'Modifiers',
  'sm.entity_history.field_name_required': 'Required',
  'sm.entity_history.field_name_cost': 'Total cost of ingredients',
  'sm.entity_history.field_name_isTaxable': 'Taxable',
  'sm.entity_history.field_name_isReturnInventory': 'Returns Inventory',
  'sm.entity_history.field_name_amount': 'Amount',
  'sm.entity_history.field_name_amountType': 'Amount Type',
  'sm.entity_history.field_name_reducedTaxAmount': 'Reduced Tax Amount',
  'sm.entity_history.field_name_reducedTaxRate': 'Reduced Tax Rate',
  'sm.entity_history.field_name_type': 'Type',
  'sm.entity_history.field_name_price': 'Price',
  'sm.entity_history.field_name_discountLabel': 'Discount Name',
  'sm.entity_history.field_name_isActive': 'Is Active',
  'sm.entity_history.field_name_applyType': 'Apply Type',
  'sm.entity_history.field_name_promoCodes': 'Promo Codes',
  'sm.entity_history.field_name_availability': 'Availability',
  'sm.entity_history.field_name_discountType': 'Discount Type',
  'sm.entity_history.field_name_menuItemSorting': 'Menu Items Sorting',
  'sm.entity_history.field_name_minimumSpend': 'Minimum Spend',
  'sm.entity_history.field_name_maximumSpend': 'Maximum Spend',
  'sm.entity_history.field_name_excludeAlcohol': 'Exclude Alcohol',
  'sm.entity_history.field_name_excludeSpendMenuGroups': 'Exclude Spend Menu Groups',
  'sm.entity_history.field_name_excludeSpendMenuItems': 'Exclude Spend Menu Items',
  'sm.entity_history.field_name_minimumPurchaseQuantity': 'Minimum Purchase Quantity',
  'sm.entity_history.event_row': '{{event}} by {{actor}} at {{date}}',
  'sm.entity_history.tax_rate': '{{rate}}%',
  'sm.entity_history.tax_amount': '${{amount}}',
  'sm.entity_history.requiresManagerOverride': 'Requires Manager Approval',
  'sm.entity_history.chargeType': 'Charge Type',
  'sm.entity_history.receivedBy': 'Received By',
  'sm.unpublished_item': 'Unpublished Item',
  'sm.saved_by': 'Saved By',
  'sm.field': 'Field',
  'sm.after': 'After',
  'sm.before': 'Before',
  'sm.select_all_banner_message_menu_groups_select_page':
    'You have selected {{pageCount}} items. <1>Select all {{count}} items in Menu Groups</1>',
  'sm.select_all_banner_message_menu_groups_select_all':
    'All {{count}} records in Menu Groups are selected. <1>Clear Selection</1>',
  'sm.select_all_banner_message_menu_items_select_page':
    'You have selected {{pageCount}} items. <1>Select all {{count}} items in Menu Items</1>',
  'sm.select_all_banner_message_menu_items_select_all':
    'All {{count}} records in Menu Items are selected. <1>Clear Selection</1>',
  'sm.select_all_banner_message_modifier_groups_select_page':
    'You have selected {{pageCount}} items. <1>Select all {{count}} items in Modifier Groups</1>',
  'sm.select_all_banner_message_modifier_groups_select_all':
    'All {{count}} records in Modifier Groups are selected. <1>Clear Selection</1>',
  'sm.select_all_banner_message_promotions_select_page':
    'You have selected {{pageCount}} Promotions. <1>Select all {{total}} items in Promotions</1>',
  'sm.select_all_banner_message_promotions_select_all':
    'All {{total}} records in Promotions are selected. <1>Clear Selection</1>',
  'sm.revision_history_title': '{{label}} Revision History',
  'sm.no_revision_history': 'Revision history not found for {{label}}',
  'sm.delete_history_title': 'Delete History',
  'sm.delete_history_title_menu': 'Menu Delete History',
  'sm.delete_history_title_menu_item': 'Menu Item Delete History',
  'sm.delete_history_title_menu_group': 'Menu Group Delete History',
  'sm.delete_history_title_sales_category': 'Sales Category Delete History',
  'sm.delete_history_title_void': 'Void Reason Delete History',
  'sm.delete_history_title_modifier_group': 'Modifier Group Delete History',
  'sm.delete_history_title_printer_group': 'Prep Station Delete History',
  'sm.delete_history_title_tax': 'Tax Delete History',
  'sm.delete_history_title_discount': 'Discount Delete History',
  'sm.delete_history_title_promotion': 'Promotion Delete History',
  'sm.delete_history_subtitle': 'Below is a log of the last 50 deleted {{entity}}.',
  'sm.deleted_entities': 'deleted entities',
  'sm.deleted_entities_menu': 'menus',
  'sm.deleted_entities_menu_item': 'menu items',
  'sm.deleted_entities_menu_group': 'menu groups',
  'sm.deleted_entities_sales_category': 'sales categories',
  'sm.deleted_entities_void': 'void reasons',
  'sm.deleted_entities_modifier_group': 'modifier groups',
  'sm.deleted_entities_printer_group': 'prep stations',
  'sm.deleted_entities_tax': 'taxes',
  'sm.deleted_entities_discount': 'discounts',
  'sm.deleted_entities_promotion': 'promotions',
  'sm.deleted_entity_title': 'Deleted Entity',
  'sm.deleted_entity_title_menu': 'Deleted Menu',
  'sm.deleted_entity_title_menu_group': 'Deleted Menu Group',
  'sm.deleted_entity_title_menu_item': 'Deleted Item',
  'sm.deleted_entity_title_sales_category': 'Deleted Sales Category',
  'sm.deleted_entity_title_void': 'Deleted Void Reason',
  'sm.deleted_entity_title_modifier_group': 'Deleted Modifier Group',
  'sm.deleted_entity_title_printer_group': 'Deleted Prep Station',
  'sm.deleted_entity_title_tax': 'Deleted Tax',
  'sm.deleted_entity_title_discount': 'Deleted Discount',
  'sm.deleted_entity_title_promotion': 'Deleted Promotions',
  'sm.no_delete_history': 'Entity has no delete history',
  'sm.no_delete_history_menu': 'No delete history found for menus',
  'sm.no_delete_history_menu_group': 'No delete history found for menu groups',
  'sm.no_delete_history_menu_item': 'No delete history found for menu items',
  'sm.no_delete_history_sales_category': 'No delete history found for sales categories',
  'sm.no_delete_history_void': 'No delete history found for void reasons',
  'sm.no_delete_history_modifier_group': 'No delete history found for modifier groups',
  'sm.no_delete_history_printer_group': 'No delete history found for prep stations',
  'sm.no_delete_history_tax': 'No delete history found for taxes',
  'sm.no_delete_history_discount': 'No delete history found for discounts',
  'sm.no_delete_history_promotion': 'No delete history found for promotions',
  'sm.delete_history': 'Delete History',
  deleted_by: 'Deleted By',

  /* VOIDS */
  'sm.voids_title': 'Made a mistake? Void it!',
  'sm.voids_explanation':
    "Voids communicate to kitchen staff any menu items that need to be removed from orders. For example: a server accidentally charges veggie tacos to the wrong table. If the order has been sent to the kitchen for preparation, the server can void the item and apply the void reason. After the void ticket has been sent to the kitchen, the server can then add the correct item to the customer's order.",
  'sm.voids_example': 'Void Example',

  /* DISCOUNTS START */
  'sm.add_discount': 'Add Discount',
  'sm.edit_discount': 'Edit Discount',
  'sm.back_to_discounts': 'Back To Discounts',
  'sm.discount_details': 'Discount Details',
  'sm.discount': 'discount',
  'sm.Discount': 'Discount',
  'sm.discounts': 'Discounts',
  'sm.delete_discount': 'Delete Discount',
  'sm.delete_discount.success': "'{{label}}' has been deleted from discounts",
  'sm.discounts_explanation': `By taking a strategic approach to discounts, your restaurant can reap the benefits and achieve your business goals - whether you want to attract new customers, drive repeat business, or increase profitability. Common discounts include: Staff, Happy Hour, or Birthday discount. You can set which Staff Types can apply Discounts on your POS.`,
  'sm.discounts_example': 'Discounts Example',
  'sm.search_discounts': 'Search discounts',
  'sm.create_discount': 'Create Discount',
  'sm.discount_type': 'Discount Type',
  'sm.discounts_applied_before_tax': 'All discounts are applied before tax.',
  'sm.select_menu_groups_for_discount': 'Select menu groups that this discount can be applied to.',
  'sm.discount_type.amount_off_items': '% or $ off Items',
  'sm.exclude_discount_attach_menu_group_and_item':
    'Select Menu Groups/Menu Items that should be excluded from the Order Level Discount',
  'sm.exclude_discount_attach_menu_group_and_item_subtitle':
    'Order level discounts apply to everything in an order, but you have the option to exclude certain items, such as alcohol, from receiving the discount. Simply choose the items or groups you want to exclude.',
  'sm.discount_attach_menu_group_and_item':
    'Select Menu Groups/Menu Items that this Discount can be applied to.',
  'sm.discount_attach_menu_group_and_item_button': 'Search Menu Groups/Menu Items',
  'sm.discount_title_menu_group': 'Select Menu Groups/Items',
  'sm.discount_title_menu_item': 'Select Menu Items',
  'sm.discount_attach_menu_group_and_item_subtitle':
    'The selected menu groups/items will be applied the discount.',
  'sm.discount_attach_menu_group_and_item_banner_title': 'Heads up!',
  'sm.discount_subtitle_menu_group':
    'Discounts will automatically include all subsequent additions to Menu Groups.',
  'sm.discount_subtitle_menu_item':
    'Discount will be applied to specific Menu Items you select. When all Menu Items are selected, the discount will apply to the Menu Group. Discount will automatically include all subsequent additions to Menu Groups.',
  'sm.discount_back_to_all': 'Back to menu groups',
  'sm.discount_view_menu_items': 'View Menu Items',
  'sm.discount_no_menu_groups': 'There are no Menu Groups.',
  'sm.discount_no_menu_items': 'There are no Menu Items for this Menu Group.',
  /* DISCOUNTS END */
  'sm.create_success': 'Your {{item}} has been successfully added',
  'sm.update_success': 'Your {{item}} has been successfully updated',
  'sm.discount_name': 'Discount Name',
  'sm.discount_name.helper': 'Your discount name can be displayed to your staff and customers.',
  'sm.amount_off': 'Amount off',
  'sm.invalid_amount': 'Discount dollar amount must be between 0.01 and 10000 with no $ symbol.',
  'sm.invalid_percent':
    'Discount percentage must be between 0.01 and 100, up to two decimal places and no % symbol.',
  'sm.discounts_replacement_discount': 'Replacement Discount for Promotion(s)',
  'sm.delete_discount_warning':
    'WARNING: Deleting this last discount will also delete the promotion(s) associated with it',
  'sm.order': 'Order',
  'sm.item': 'Item',
  'sm.ad_order': 'Bill',
  'sm.ad_item': 'Item',
  'sm.ad_cash': 'Cash',
  'sm.ad_bogo': 'Buy X Get Y',
  'sm.discount_type_item': '% or $ off Items',
  'sm.discount_type_order': '% or $ off Order',
  'sm.discount_type_helper': 'Once a discount type has been saved, it cannot be edited.',

  /* ADVANCED DISCOUNT START */
  'sm.empty_discount_list': 'You currently don’t have any Discounts',
  'sm.create_new_discount': 'Create Discount',
  'sm.enum_ACTIVE': 'Active',
  'sm.enum_INACTIVE': 'Inactive',
  'sm.discount_amount': 'Amount',
  'sm.discount_available_for': 'Available For',
  'sm.discount_method': 'Method',
  'sm.status': 'Status',
  'sm.combo': 'Combo - {{comboPricingMethod}}',
  'sm.fixed_price': 'Fixed Price',
  'sm.fixed_discount': 'Fixed Discount',
  'sm.bogo': 'Buy X Get Y',
  'sm.discount_apply_type_manual': 'Manual',
  'sm.discount_apply_type_automatic': 'Automatic',
  'sm.discount_apply_type_promo': 'Promo Code',
  'sm.promo_code_form_code': 'Promo Code',
  'sm.promo_code_form_description': 'Description',
  'sm.promo_code_form_start_date': 'Start Date & Time',
  'sm.promo_code_form_end_date': 'End Date & Time',
  'sm.promo_code_form_start_time': 'Start Time',
  'sm.promo_code_form_end_time': 'End Time',
  'sm.promo_code_form_status_active': 'Active',
  'sm.promo_code_form_status_expired': 'Expired',
  'sm.promo_code_form_status_scheduled': 'Scheduled',
  'sm.discount_form_subHeader_availability': 'Availability',
  'sm.discount_form_availability_subHeader_text':
    'Define the conditions for when the discount will apply',
  'sm.discount_form_label_promoCode': 'Promo Code',
  'sm.discount_form_promoCode_label_text':
    'Create promo codes that customers can use to claim the discount at the venue or during the checkout for online orders',
  'sm.discount_form_action_add_promoCode': 'Add Promo Code',
  'sm.discount_form_label_availableFor': 'Available For',
  'sm.discount_form_availableFor_label_text':
    'Third party applications are excluded from this discount\n(Disclaimer: This discount will not be available for third party applications)',
  'sm.discount_form_label_applyDiscount': 'Apply Discount',
  'sm.discount_form_applyDiscount_options': {
    AUTOMATIC: 'Automatically',
    MANUAL: 'Manually',
    PROMO: 'Promo Codes',
  },
  'sm.discount_form_label_availableWhen': 'What is the availability of this discount?',
  'sm.discount_create_success': 'Discount Created',
  'sm.discount_update_success': 'Discount Updated',
  'sm.discount_detail_description': 'Discounts will only be applied before taxes',
  'sm.discount_detail_type_item_1_label': 'Item Discount',
  'sm.discount_detail_type_item_1_description': 'Fixed $ or % off an item',
  'sm.discount_detail_type_item_2_label': 'Bill Discount',
  'sm.discount_detail_type_item_2_description': 'Fixed $ or % off the bill',
  'sm.discount_detail_type_item_3_label': 'Combo Discount',
  'sm.discount_detail_type_item_3_description': 'Configure a combo to provide a discount',
  'sm.discount_detail_type_item_4_label': 'Buy X Get Y',
  'sm.discount_detail_type_item_4_description': 'Purchase certain items and receive a discount',
  'sm.discount_detail_type_item_5_label': 'Cash Discount',
  'sm.discount_detail_type_item_5_description': 'Fixed % off the bill when paying with cash',
  'sm.discount_detail_type_item_5_venue_disabled':
    'Cash discounts can only be created at the group level',
  'sm.discount_detail_type_item_5_exists_disabled': 'You can only have one cash discount at a time',
  'sm.discount_amount_advanced': 'Discount Amount',
  'sm.discount_amount_fixed_advanced': 'Fixed Price ({{currencySymbol}})',
  'sm.discount_min_spend': 'Minimum Spend',
  'sm.discount_max_spend': 'Max Spend',
  'sm.discount_min_spend_placeholder': 'Minimum amount ({{currencySymbol}})',
  'sm.discount_max_spend_placeholder': 'Max amount ({{currencySymbol}})',
  'sm.discount_min_max_helper':
    'The bill amount must be above the minimum amount for the discount to apply',
  'sm.discount_amount_helpertext': 'The amount that will be discounted from the bill',
  'sm.discount_fixed_amount_helpertext':
    'Set the price of the item. Any additional charges from modifiers won’t be included in this price.',
  'sm.invalid_discount_name_required': 'Discount name is required',
  'sm.invalid_discount_name_length': 'Discount name cannot exceed 250 characters',
  'sm.invalid_discount_type': 'Choose a discount type',
  'sm.invalid_discount_amount_required': 'Discount amount is required',
  'sm.invalid_discount_amount_type': 'Discount amount must be a number',
  'sm.invalid_sales_channel': 'At least one sales channel required',
  'sm.invalid_promo_codes_format': 'Promo code should not contain Spaces or Symbol',
  'sm.invalid_promo_codes_length': 'At least one promo code must be added',
  'sm.stock': 'Stock',
  'sm.stock_availability': 'Stock Availability',
  'sm.stock_count': 'Stock Count',
  'sm.low_stock_indicator': 'Low Stock Indicator',
  'sm.add_stock': 'Add Stock',
  'sm.manage_stock': 'Manage Stock',
  'sm.stock_availability.no_items_found':
    "You currently don't have any Menu Items configured to use Stock Availability",
  'sm.stock_availability.no_items_found_alt':
    'TouchBistro no Menu Items configured to use Stock Availability image',
  'sm.menu.stock_availability.add_modal.title': '{{label}} Stock',
  'sm.menu.stock_availability.add.success': '{{label}} stock has been successfully added.',
  'sm.menu.stock_availability.starting_count.label': 'Enter your starting stock',
  'sm.menu.stock_availability.starting_count.required': 'Please enter a stock amount',
  'sm.menu.stock_availability.set_count.max_exceeded':
    'The amount you entered cannot exceed {{maxCount}}',
  'sm.menu.stock_availability.low_stock_toggle.label': 'Low Stock Indicator',
  'sm.menu.stock_availability.low_stock.required': 'Please enter a low stock amount',
  'sm.menu.stock_availability.low_stock.below_min':
    'The amount you entered cannot be below {{minLowStockCount}}',
  'sm.menu.stock_availability.update_modal.radio_title': 'Add or remove from your Stock Count',
  'sm.menu.stock_availability.update_modal.radio_add': 'Add to stock',
  'sm.menu.stock_availability.update_modal.radio_remove': 'Remove from stock',
  'sm.menu.stock_availability.update_modal.stock_count_amount': 'Amount',
  'sm.menu.stock_availability.update_modal.stock_count_existing': 'Stock: {{stockCount}}',
  'sm.menu.stock_availability.update_modal.stock_count_equation':
    'Stock: {{stockCount}} {{sign}} {{amount}} = {{sum}}',
  'sm.menu.stock_availability.update_modal.stock_count.required': 'Please enter a stock amount',
  'sm.menu.stock_availability.update_modal.stock_count.sum_exceeds_max':
    'The new stock total cannot exceed {{maxCount}}',
  'sm.menu.stock_availability.update_modal.stock_count.sum_below_zero':
    'The amount to remove cannot be more than your current stock',
  'sm.menu.stock_availability.update_modal.disable_stock_count': 'Disable Stock Count',
  'sm.menu.stock_availability.disable_stock_count_modal.title':
    'Are you sure you want to disable your stock count?',
  'sm.menu.stock_availability.disable_stock_count_modal.message':
    'Any Stock Count will be removed and you will no longer receive Low Stock Indicators. If you enable stock count again, you will have to input a new starting stock count.',
  'sm.menu.stock_availability.disable_stock_count_modal.confirm': 'Disable Stock',
  'sm.menu.stock_availability.update.success': '{{label}} stock has been successfully updated.',
  'sm.menu.stock_availability.update.restock': '{{label}} is available again.',
  'sm.menu.stock_availability.update.no_item_selected': 'No item has been selected',
  'sm.menu.stock_availability.update.item_not_in_list':
    'Item to be updated is not in the item list',
  'sm.menu.stock_availability.invalid_initial_stock_count_error':
    'The amount you entered cannot be below 0 or exceed {{maxCount}}',
  'sm.menu.stock_availability.request_error': 'Failed to update Stock Availability',
  'sm.menu.stock_availability.oos_confirmation.title':
    'Marking {{label}} out of stock will disable the stock count',
  'sm.menu.stock_availability.oos_confirmation.text':
    'Any Stock Count will be removed and you will no longer receive Low Stock Indicators. If you enable stock count again, you will have to input a new starting stock count.',
  'sm.menu.stock_availability.oos_confirmation.mark_out_of_stock': 'Mark Out of Stock',
  'sm.menu.stock_availability.oos_choice.title':
    'Making {{label}} available immediately will disable the stock count',
  'sm.menu.stock_availability.oos_choice.text':
    '{{label}} has 0 Stock Count. Making it available will disable stock count so it can be sold immediately. To keep your stock count, just add to the Stock Count.',
  'sm.menu.stock_availability.oos_choice.make_available_now': 'Make Available Now',
  'sm.menu.stock_status_all_items': 'All Items',
  'sm.menu.stock_status_in_stock': 'Items In Stock',
  'sm.menu.stock_status_out_of_stock': 'Items Out Of Stock',
  'sm.menu.stock_status_low_stock': 'Items With Low Stock',
  'sm.discount_applicaple_group_section_title': 'Applicable Groups/Items',
  'sm.discount_exclude_group_section_title': 'Exclude Groups/Items',
  'sm.discount_configure_get_buy_section_title': 'Configure Buy & Get Items',
  'sm.discount-buy_group_section_title': 'Buy Groups/Items',
  'sm.discount-buy_group_section_description':
    'Select menu groups/items the customer needs to purchase',
  'sm.discount-buy_group_section_dialog_description':
    'Add menu groups/items customers need to purchase to get a discount. They can purchase any of the\n selected in order to apply the discount',
  'sm.discount-get_group_section_title': 'Get Groups/Items',
  'sm.discount-get_group_section_description':
    'Select menu groups/items the discount will apply to',
  'sm.discount-get_group_section_dialog_description':
    'Add menu groups or items the discount will apply to if a customer purchases from the “Buy Groups/Items”',
  'sm.discount_validation_item_groups': 'At least one group or item must be selected',
  'sm.discount_validation_bogo_buy': 'At least one item must be selected for the "Buy" group',
  'sm.discount_validation_bogo_get': 'At least one item must be selected for the "Get" group',
  'sm.delete_advanced_discount_message': 'Deleting this discount will not affect your past reports',
  'sm.discount_type_item_section_description':
    'Select the menu groups/items that the discount will apply to',
  'sm.discount_type_order_section_description': 'Exclude menu groups/items from the discount',
  'sm.discount_type_bogo_section_description':
    'Define items that need to be purchased and items that will receive the discount',
  'sm.discount__select-modal-confirm-item-title': 'Please confirm',
  'sm.discount_select-modal-confirm-item-text':
    'Deselecting this Menu Item will deselect the Menu Group to which it belongs.',
  'sm.discount_promo_code_warning_title':
    'Applying the discount automatically will remove all Promo Codes created',
  'sm.discount_promo_code_warning_subtitle': 'Are you sure you want to switch?',
  'sm.discount_promo_code_apply_automatically_btn': 'Apply Automatically',
  'sm.discount_promo_code_apply_manually_btn': 'Apply Manually',
  'sm.discount_min_max_spend_title': 'Minimum Spend',
  'sm.discount_min_max_spend_caption':
    'Set a minimum spend requirement before the discount is applied, and choose whether to exclude specific menu groups/items from the total spend',
  'sm.discount_min_max_spend_label': 'Require a minimum spend for this discount?',
  'sm.discount_min_max_spend_radio_label_0': 'Set a minimum spend requirement',
  'sm.discount_min_max_spend_radio_label_1': 'No spend requirement',
  'sm.discount_exclude_all_alcohol': 'Exclude all Alcohol',
  'sm.discount_exclude_groups_items_description':
    'Exclude menu groups/items from contributing to the minimum spend',
  'sm.validation_min_quantity_required': 'A minimum quantity must be provided',
  'sm.validation_min_or_max_required': 'A minimum spend must be provided',
  'sm.validation_sales_channel': 'At least one SalesChannel must be selected',
  'sm.validation_promo_code': 'At least one promo code must be added',
  'sm.discount_minimum_quantity': 'Minimum Quantity Purchase',
  'sm.discount_minimum_quantity_helper':
    'Select the minimum quantity to purchase from "Buy Groups/Items" to receive a discount on "Get Groups/Items"',
  'sm.discount_availability_option_1': 'At all times',
  'sm.discount_availability_option_2': 'Selected days and times',
  'sm.discount_item_amount_type_AMOUNT': 'Discount Amount',
  'sm.discount_item_amount_type_FIXED': 'Fixed Price',
  'sm.discount_item_amount_type_label': 'Select the pricing method',
  'sm.discount_schedule_title': 'Available dates and times',
  'sm.discount_schedule_subtitle':
    'Indicate when the discount should be available for each day of the week.',
  'sm.discount_schedule_day_pick_error': 'Please select the day(s) your discount is available.',
  'sm.discount_schedule_start_differ_end_error': 'Ensure there are no overlapping time slots below',
  'sm.validation_schedule_required': 'Please select at least one day for the discount schedule',
  'sm.no_prep_stations_available': 'No Prep Stations Available',

  // Group and Item Selector Shared component
  group_item_selector_view_all_button: 'View All',
  group_item_selector_dialog_view_all: 'Click x to remove a group/item',
  group_item_selector_menu_items_count_msg: '{{count}} Menu Items',
  group_item_selector_menu_group_item_count: '{{count}} items',
  group_item_selector_menu_items_tab: 'Menu Items',
  group_item_selector_menu_items_count_tab: 'Menu Items ({{count}})',
  group_item_selector_menu_group_tab: 'Menu Groups',
  group_item_selector_menu_group_count_tab: 'Menu Group ({{count}})',
  'group_item_selector_select-menu-items-groups-btn': 'Select Groups/Items',
  group_item_selector_no_group_selection: 'No Menu Group Selected',
  group_item_selector_no_item_selection: 'No Menu Item Selected',
  group_item_selector_exculde_all_alcohol: 'Exclude all Alcohol',
  group_item_selector_menu_group_removed: '[REMOVED GROUP]',
  group_item_modal_selector_descr_include:
    'Select menu groups/items that the discount will apply to',
  group_item_modal_selector_descr_exclude: 'Select groups/items the discount can’t be applied to',
}

export default simplifiedMenuEN
